export default __webpack_public_path__ + "static/media/H1007.76c31ce6.mp3";